import { Pagination } from '@nextui-org/react';
import { useDispatch, useSelector } from 'react-redux'

import {
    Table,
    Thead,
    Tbody,
    Tfoot,
    Tr,
    Th,
    Td,
    TableCaption,
    TableContainer,
  } from '@chakra-ui/react'

  
  import "./allCompany.css"
import { getCaompanyAllAction } from '../../../../redux/reducer/getAllCompanyForAdmin/action/action';

import { useEffect, useRef, useState, useTransition } from 'react';
import { getadminInfoAction } from '../../../../redux/reducer/getAdminInfo/action/action';
import ModalEdit from './modalForEdit/modaleditCompany';
import axios from 'axios';
import DeleteCompanyByAdmin from './deleteCompany/deleteCompany';
import Spinner from 'react-bootstrap/Spinner';




export default function AllCompany() {

    const [show, setShow] = useState(false);
    const [data, setData] = useState(false);
    const [isPending, startTransition] = useTransition();
    const [currentPage, setCurrentPage] = useState(1);
    const [seatchVal, setseatchVal] = useState("");

    const dispatch = useDispatch()
    const getAllCompany = useSelector(compnay => compnay)
    const selectForm = useRef(null)

    useEffect(()=>{
        
        dispatch(getadminInfoAction("/getadmininfo/admin/api"))
        
    },[dispatch])


    useEffect(() => {
   
        if (seatchVal == "") {
            dispatch(getCaompanyAllAction(`/getAllCompant/admin/api?page=${currentPage}`))
        }else{
            dispatch(getCaompanyAllAction(`/searchbyinputcompany/api?search=${seatchVal}&page=${currentPage}`))
            }
    
       
      }, [currentPage]);

       
    const handleSubmit = (e) => {   
        setCurrentPage(1)
     
        setseatchVal(e.target.value)
       
        if (selectForm.current.browser.value == "") {
            dispatch(getCaompanyAllAction(`/getAllCompant/admin/api?page=${currentPage}`))
        }else{
            dispatch(getCaompanyAllAction(`/searchbyinputcompany/api?search=${selectForm.current.browser.value}&page=${currentPage}`))
        }
       
            e.PreventDefault()
        selectForm.current.submit()
      
    }


const setDataForEdit=(item)=>{
    setData(item)
    console.log(data);
    setShow(true)


}





const handlePageChange = (page) => {
    setCurrentPage(page);
   
  };



                if (getAllCompany.getAllCompanyForAdminReducer.allCompany.data != undefined && getAllCompany.getAllCompanyForAdminReducer.allCompany.data != "") {
                    return(
                        <>
                         
                        <h1  className="titleH1">Поиск компании</h1>
                        <form className="searchContForm" onChange={handleSubmit} ref={selectForm}>
                                
                                    <input list="browsers" name="browser" id="browser" placeholder='Поиск компании' value={seatchVal}/>
                                    <datalist id="browsers">
                                        <option value="Edge" />
                                        <option value="Firefox" />
                                        <option value="Chrome" />
                                        <option value="Opera" />
                                        <option value="Safari" />
                                    </datalist>
                                    
                                    </form>
                            <div className="allCompany">
                            {getAllCompany.getAllCompanyForAdminReducer.loading?
                                <div className="loading">
                                <Spinner animation="border" size="sm" />

                           </div>
                            :
                            <TableContainer>
                            <Table variant='simple'>
                                
                                <Thead>
                                <Tr>
                                    <Th>Название компании</Th>
                                    <Th>ИД КОМПАНИИ</Th>
                                    <Th isNumeric>ИНН</Th>
                                    <Th isNumeric>Сотрудники</Th>
                                    <Th isNumeric>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Th>
                                </Tr>
                                </Thead>
                                <Tbody>
                            {getAllCompany.getAllCompanyForAdminReducer.allCompany.data.map((item,index)=>{
                                    console.log(item,"alladmin");
                                    return(
                                        <Tr key={index} >
                                             <ModalEdit setShows={setShow} shows={show} data={data} currentPage={currentPage} key={index} index={index}/>
                                                <Td onClick={()=>setDataForEdit(item)} >{item.sellersname}</Td>
                                                <Td onClick={()=>setDataForEdit(item)} >{item._id} </Td>
                                                <Td onClick={()=>setDataForEdit(item)}  isNumeric>{item.inn}</Td>
                                                <Td onClick={()=>setDataForEdit(item)}  isNumeric>{item.workers.length}</Td>
                                                <Td isNumeric > <DeleteCompanyByAdmin item={item} /> </Td>      

                                    </Tr>
                                    )
                            })}
                               
                               
                                </Tbody>
                                
                            </Table>
            </TableContainer>
                            }
                            
                               
                                <div className="paginationCompany">
                                <Pagination total={getAllCompany.getAllCompanyForAdminReducer.allCompany.totalPages} initialPage={getAllCompany.getAllCompanyForAdminReducer.allCompany.currentPage} onChange={handlePageChange} />
                                       
                                </div>
                        </div>
                       
                        </>
                    )
                }
        return (
            <>
                <h1>нет компании</h1>
                <form className="searchContForm" onChange={handleSubmit} ref={selectForm}>
                                
                                    <input list="browsers" name="browser" id="browser" placeholder='Поиск компании'/>
                                    <datalist id="browsers">
                                        <option value="Edge" />
                                        <option value="Firefox" />
                                        <option value="Chrome" />
                                        <option value="Opera" />
                                        <option value="Safari" />
                                    </datalist>
                                    
                                    </form>
                                  
            </>
        )
}